export default __webpack_public_path__ + "static/media/graph-up.2f3e9b6c.svg";